import { BodyPrimary } from '@liveauctioneers/caterwaul-components/lib/Text/Text/index';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

const getIcon = (idx) => `https://p1.liveauctioneers.com/dist/images/icon${idx}.png`;

type Props = {
    sellerName: string;
};

const SendSellerConsignmentMessageReasons = ({ sellerName }: Props) => {
    return (
        <ReasonWrapper>
            <StyledReasonHeader>
                <FormattedMessage
                    id="why_consign_with"
                    values={{ sellerName }}
                />
            </StyledReasonHeader>
            <ReasonContainer>
                <Reason>
                    <img src={getIcon(2)} />
                    <FormattedMessage id="licensed_auctioneer" />
                </Reason>
                <Reason>
                    <img src={getIcon(1)} />
                    <FormattedMessage id="reach_millions" />
                </Reason>
                <Reason>
                    <img src={getIcon(3)} />
                    <FormattedMessage id="discover_the_value" />
                </Reason>
            </ReasonContainer>
        </ReasonWrapper>
    );
};

export default SendSellerConsignmentMessageReasons;

const ReasonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 147px;
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.grey500};
    color: ${({ theme }) => theme.colors.black};
`;

const StyledReasonHeader = styled(BodyPrimary)`
    font-size: 16px;
    line-height: 1.38;
    padding-bottom: 14px;
`;

const ReasonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 12px;
`;

const Reason = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    letter-spacing: 0.5px;
    width: 142px;

    img {
        height: 35px;
        padding-bottom: 6px;
    }
`;
